export const BookingSerchListConst = [
  { id: "producerId", value: "producerId", label: "Producer" },
  { id: "buyerId", value: "buyerId", label: "Buyer" },
  { id: "haulierCode", value: "haulierCode", label: "Haulier" },
  { id: "address", value: "address", label: "Address 1" },
  { id: "notes", value: "notes", label: "Notes" },
  { id: "quantity", value: "quantity", label: "Quantity" },
];
export const BookingStatusListConst = [
  { id: "2", label: "All" },
  { id: "1", label: "Booked" },
  { id: "0", label: "Available" },
];

export const tagBasePriceOptions = ["General Info", "Personel", "Farm & Location"];

export enum TimeLineEnum {
  ALL_DAY = 24,
  ALL_BOOKINGS_PER_DAY = 6 * 24,
}

export enum SpeciesEnum {
  CATTLE = "C",
  SHEEP = "S",
}

export enum BookingStatusListEnum {
  All = "2",
  BOOKED = "1",
  AVAILABLE = "0",
}

export enum BookingSettingsEmum {
  RECYCLE_BIN = 1,
  TABLE_SETTING = 2,
  PRINT = 3,
}
